export default class practiceConstants {
  static allCategory = {
    title: 'Все разделы',
    alias: null,
    description: '',
  };

  static sortTypes = [
    {
      id: 0,
      title: "Дате загрузки",
      alias: 'date'
    },
    {
      id: 1,
      title: "Количеству голосов",
      alias: 'likes'
    }
  ];
};